import { FC } from "react";

export interface PortfolioHeaderContent {
  heading?: string;
  description?: string;
  componentPostion?: string;
}

export interface PortfolioHeaderProps {
  content: PortfolioHeaderContent;
}

const PortfolioHeader: FC<PortfolioHeaderProps> = ({ content }) => {
  const heading = content?.heading ?? "Portfolio";
  const description = content?.description ?? "Know about your portfolio";

  return (
    <div className="px-[16px] py-[12px]">
      <h1 className="text-[20px] font-medium text-[#1A1A1A] sm:text-[22px]">
        {heading}
      </h1>
      <p className="text-[12px] text-[#1A1A1A]">{description}</p>
    </div>
  );
};

export default PortfolioHeader;
